import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const CompaniesWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default CompaniesWrapper